// This file serves as a proxy to the main WorldScene implementation
// Import the actual implementation from the worldscene directory
import WorldSceneIndex from './worldscene/index';

// Export the WorldSceneIndex as the default export
export default WorldSceneIndex;